import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface ExternalCollectionsState {
  activeCollectionID: number | null;
}

const initialState: ExternalCollectionsState = {
  activeCollectionID: null,
};

export const externalCollectionsSlice = createSlice({
  name: "external-collections",
  initialState: initialState,
  reducers: {
    setActiveExternalCollectionID: (
      state,
      action: PayloadAction<number | null>,
    ) => {
      state.activeCollectionID = action.payload;
    },
  },
});

export const { setActiveExternalCollectionID } =
  externalCollectionsSlice.actions;

export const selectActiveExternalCollectionID = (state: RootState) =>
  state.externalCollections.activeCollectionID;

export default externalCollectionsSlice.reducer;
